import { TableHeader } from "@/models/TableHeader";

export const surveyResponsesHeaders: TableHeader[] = [
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Date Surveyed",
    value: "updated_at"
  },
  {
    text: "Facility",
    value: "facility_id"
  },
  {
    text: "Email",
    value: "email"
  },
  {
    text: "Phone",
    value: "phone",
    sortable: false
  }
];
